import { Fragment } from 'react';
import { Checkbox, Link, Tooltip } from 'components/common';
import { format } from 'utils/date';
import { compactNumber, formatCurrency, formatRange } from 'utils/number';
import { makeHttpsUrl } from 'utils/helpers/externalLink';
import { formatLocation } from 'utils/geo';
import { colours } from 'utils/theme';
import SocialMediaLink from 'components/Researcher/Profile/SocialMediaLink';
import { LockedIcon } from './LockIcon';
import { CenterItem, HeaderIcon, TwoLineLabel } from './styled';

const getConfig = (
  listId,
  selectedMembers,
  someSelected,
  allSelected,
  handleToggleAll,
  handleToggleMember
) => ({
  headers: [
    {
      testId: 'checkbox',
      label: (
        <Checkbox
          checked={allSelected}
          indeterminate={someSelected}
          onClick={handleToggleAll}
        />
      ),
      minWidth: 20,
    },
    { label: 'Organisation', key: 'name', minWidth: 150, maxContentWidth: 250 },
    { label: 'Category', key: '', minWidth: 100 },
    {
      label: (
        <CenterItem>
          <Tooltip title='Funding Awards'>
            {' '}
            <HeaderIcon icon='award' color={colours.grants} size='xl' />{' '}
          </Tooltip>
        </CenterItem>
      ),
      minWidth: 30,
    },
    {
      label: (
        <CenterItem>
          <Tooltip title='Posters'>
            {' '}
            <HeaderIcon icon='image' color={colours.posters} size='xl' />{' '}
          </Tooltip>
        </CenterItem>
      ),
      minWidth: 30,
    },
    {
      label: (
        <CenterItem>
          <Tooltip title='Publications'>
            {' '}
            <HeaderIcon
              icon='book'
              color={colours.publications}
              size='xl'
            />{' '}
          </Tooltip>
        </CenterItem>
      ),
      minWidth: 30,
    },
    {
      label: (
        <CenterItem>
          <Tooltip title='Clinical Trials'>
            {' '}
            <HeaderIcon icon='trial' color={colours.trials} size='xl' />{' '}
          </Tooltip>
        </CenterItem>
      ),
      minWidth: 30,
    },
    {
      label: (
        <TwoLineLabel>
          Funding <div>(Last 3 Years)</div>
        </TwoLineLabel>
      ),
      minWidth: 50,
    },
    { label: 'Location', key: '', minWidth: 100 },
    { label: 'Size', key: 'sizeRangeLowerBound', minWidth: 100 },
    { label: 'Founded Date', key: 'foundedYear', minWidth: 100 },
    { label: 'LinkedIn', key: '', minWidth: 50 },
    { label: 'Added On', key: 'dateAddedUtc', minWidth: 100 },
    { label: 'Added By', key: 'addedbyuser', minWidth: 100 },
  ],
  createRow: (r, i) => (
    <Fragment key={`${r.name}-${i}`}>
      <div>
        <Checkbox
          checked={
            !selectedMembers.exclude[r.id] &&
            (selectedMembers.include[r.id] || selectedMembers.all)
          }
          onClick={() => handleToggleMember(r.id)}
        />
      </div>
      <div>
        <Link to={`/organisation/${r.id}`}>{r.name}</Link>
      </div>
      <div>
        {r.locked ? (
          <LockedIcon />
        ) : (
          <Tooltip title={r.category} placement='right'>
            <div
              style={{
                maxWidth: 150,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'pointer',
              }}
            >
              {r.category}
            </div>
          </Tooltip>
        )}
      </div>
      <CenterItem>
        {r.locked ? <LockedIcon /> : compactNumber(r.totalGrants) || 0}
      </CenterItem>
      <CenterItem>
        {r.locked ? <LockedIcon /> : compactNumber(r.totalSessions) || 0}
      </CenterItem>
      <CenterItem>
        {r.locked ? <LockedIcon /> : compactNumber(r.totalPublications) || 0}
      </CenterItem>
      <CenterItem>
        {r.locked ? <LockedIcon /> : compactNumber(r.totalClinicalTrials) || 0}
      </CenterItem>
      <div>
        {r.locked ? (
          <LockedIcon />
        ) : r.threeYearTotalFunding ? (
          `$${formatCurrency(r.threeYearTotalFunding)}`
        ) : (
          ''
        )}
      </div>
      <div>
        {r.locked ? <LockedIcon /> : formatLocation(null, r.state, r.country)}
      </div>
      <div>
        {r.locked ? (
          <LockedIcon />
        ) : (
          (r.sizeRangeLowerBound > 0 || r.sizeRangeUpperBound > 0) &&
          formatRange(r.sizeRangeLowerBound, r.sizeRangeUpperBound)
        )}
      </div>
      <div>{r.locked ? <LockedIcon /> : r.foundedYear}</div>
      <div>
        {r.locked ? (
          <LockedIcon />
        ) : (
          <SocialMediaLink
            network={{
              type: 'linkedin',
              displayName: 'LinkedIn',
            }}
            title={r.linkedIn ? 'View on LinkedIn' : 'Search for LinkedIn'}
            url={
              r.linkedIn
                ? makeHttpsUrl(r.linkedIn)
                : `http://www.google.com/search?q=${r.name} site:linkedin.com`
            }
            isMuted={!r.linkedIn}
            logDescription={{
              entityType: 'Organisation',
              location: `Lists:${listId}`,
            }}
          />
        )}
      </div>
      <div>{format(r.dateAddedUtc)}</div>
      <div>{r.addedByUser}</div>
    </Fragment>
  ),
});

export default getConfig;
